import { render } from "./TimeScale.vue?vue&type=template&id=0bb4ba24&scoped=true"
import script from "./TimeScale.vue?vue&type=script&lang=js"
export * from "./TimeScale.vue?vue&type=script&lang=js"

import "./TimeScale.vue?vue&type=style&index=0&id=0bb4ba24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb4ba24"]])

export default __exports__